import React, { useState } from 'react';
import AdminLayout from '../../../layouts/AdminLayout';
import { useNavigate } from 'react-router-dom';
import { adminPaths } from '../../../routes/admin';

const Services = () => {
    const navigate = useNavigate();
    const [isAddServiceModalOpen, setIsAddServiceModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState("");
    const serviceOptions = [
        "Sales",
        "Marketing",
        "UI/UX Design",
        "Mobile Design",
        "Customer Service",
        "Product Management",
        "Software Development",
    ];

    return (
        <>
            <AdminLayout>
                <div className="ct_px_40 mt-4">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
                            <h4 className="mb-0 ct_fs_20 mb-4">Services</h4>
                            <div
                                className={`ct_filter_sidebar ct_custom_scroll p-0`}
                            >
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">Account Status</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Active
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Suspended
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Pending Approval
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Deactivated
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">Activity Level</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Last Active: Today
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Last 7 Days
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    30+ Days Inactive
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">User Plan</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Nuglow
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Nuforge
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Nustar
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Free
                                                </label>
                                            </div>
                                        </li>
                                        <li className="mt-2">
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Others
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <h5 className="ct_fs_16 mb-3">Flagged</h5>
                                    <ul>
                                        <li>
                                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                />
                                                <label for="" className="ct_text_clr_757886">
                                                    Show Only Flagged Users
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-9 mb-4 mb-md-0">
                            <div className="d-flex align-items-center gap-3 justify-content-between mb-4 ct_flex_col_1199 pb">
                                <div>
                                    <h4 className="mb-0 ct_fs_20 mb-0">Manage Services</h4>
                                    <p className="mb-0 ct_text_clr_757886">
                                        View, filter, and take action across all Nuvio user types
                                    </p>
                                </div>
                                <div className="d-flex align-items-center gap-3 justify-content-end  ct_flex_col_575">
                                    {/* <div className="position-relative ct_w_100_575">
                                        <input
                                            type="text"
                                            className="form-control ct_input ct_h_35 ps-5"
                                            placeholder="Search by Name"
                                        />
                                        <i className="fa-solid fa-search ct_input_icon_left"></i>
                                    </div> */}
                                    <div className="position-relative ct_w_100_575">
                                        <button
                                            type="button"
                                            className="ct_yellow_btn ct_h_35 ct_w_100_575"
                                            onClick={() => setIsAddServiceModalOpen(true)}
                                        >
                                            Add Services
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isAddServiceModalOpen && (
                    <>
                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content border-0" style={{ borderRadius: "12px" }}>
                                    <div className="modal-header border-0 pb-0">
                                        <h5 className="modal-title">Add Service</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            aria-label="Close"
                                            onClick={() => setIsAddServiceModalOpen(false)}
                                        ></button>
                                    </div>
                                    <div className="modal-body pt-2">
                                        {/* <label className="mb-2 ct_fs_16">Select Service</label> */}
                                        <div className="d-flex flex-column gap-2 position-relative">
                                            <select
                                                className="form-select ct_input ct_h_45"
                                                value={selectedService}
                                                onChange={(e) => {
                                                    setSelectedService(e.target.value)
                                                    navigate(adminPaths.AddServices, { state: { data: e.target.value } })
                                                }}
                                            >
                                                <option value="">Select a service</option>
                                                {serviceOptions.map((service) => (
                                                    <option key={service} value={service}>
                                                        {service}
                                                    </option>
                                                ))}
                                            </select>
                                            <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                        </div>
                                    </div>
                                    {/* <div className="modal-footer border-0 pt-0">
                                        <button
                                            type="button"
                                            className="ct_yellow_btn ct_outline_grey ct_h_35 px-4"
                                            onClick={() => setIsAddServiceModalOpen(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="ct_yellow_btn ct_h_35 px-4"
                                            onClick={() => setIsAddServiceModalOpen(false)}
                                        >
                                            Save
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                )}
            </AdminLayout>
        </>
    )
};

export default Services;
